function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-list-normal_svg__clip0)",
  fill: "#879097"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.963 15.932H2.297c-1.081 0-1.958.893-1.958 1.995 0 1.1.877 1.994 1.958 1.994h15.666c1.081 0 1.958-.893 1.958-1.994s-.877-1.995-1.958-1.995zM17.963 7.954H2.297C1.216 7.954.34 8.847.34 9.95c0 1.101.877 1.994 1.958 1.994h15.666c1.081 0 1.958-.893 1.958-1.994 0-1.102-.877-1.995-1.958-1.995zM2.297 3.965h15.666c1.081 0 1.958-.893 1.958-1.995 0-1.101-.877-1.994-1.958-1.994H2.297C1.216-.024.34.87.34 1.97c0 1.102.877 1.995 1.958 1.995z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-list-normal_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgIconListNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconListNormal;